module.exports = __webpack_public_path__ + "img/more_bonus.3300810e.png";